import type { SelfServiceAPI } from 'types';
import { getBookingCancellationQuotePageLink } from 'lib/links';
import getStageSuffix from '../getStageSuffix';

const getPathNameForStage = (bookingId: string, stage: SelfServiceAPI.CancellationState, error?: Error) => {
  const suffix = getStageSuffix(stage, error);

  return getBookingCancellationQuotePageLink(bookingId, suffix);
};

export default getPathNameForStage;
